import Rates from './Rates';
export default Rates;